<template>
  <b-form @submit.prevent="onSubmit">
    <h3>Dane ogólne</h3>

    <b-form-group label="Imię">
      <b-form-input
        v-model="firstName"
        type="text"
        autocomplete="off"
        :state="$v.firstName.$error? false : null"
        @input="$v.firstName.$reset()"
      />
      <b-form-invalid-feedback>
        <div v-if="!$v.firstName.required">To pole jest wymagane</div>
        <div
          v-if="!$v.firstName.maxLength"
        >Pole nie może zawierać więcej niż {{$v.firstName.$params.maxLength.max}} znaków</div>
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Nazwisko">
      <b-form-input
        v-model="lastName"
        type="text"
        autocomplete="off"
        :state="$v.lastName.$error? false : null"
        @input="$v.lastName.$reset()"
      />
      <b-form-invalid-feedback>
        <div v-if="!$v.lastName.required">To pole jest wymagane</div>
        <div
          v-if="!$v.lastName.maxLength"
        >Pole nie może zawierać więcej niż {{$v.lastName.$params.maxLength.max}} znaków</div>
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Numer telefonu">
      <b-form-input
        v-model="phoneNumber"
        type="number"
        autocomplete="off"
        :state="$v.phoneNumber.$error? false : null"
        @input="$v.phoneNumber.$reset()"
      />
      <b-form-invalid-feedback>
        <div v-if="!$v.phoneNumber.required">To pole jest wymagane</div>
        <div v-if="!$v.lastName.isPhone">Nieprawidłowy numer telefonu</div>
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Skype">
      <b-form-input
        v-model="skypeLogin"
        type="text"
        autocomplete="off"
        :state="$v.skypeLogin.$error? false : null"
        @input="$v.skypeLogin.$reset()"
      />
      <b-form-invalid-feedback>
        <div v-if="!$v.skypeLogin.required">To pole jest wymagane</div>
        <div
          v-if="!$v.skypeLogin.maxLength"
        >Pole nie może zawierać więcej niż {{$v.skypeLogin.$params.maxLength.max}} znaków</div>
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group>
      <b-button
        class="float-right"
        type="submit"
        variant="primary"
        :disabled="loading"
        @click="$v.$touch"
      >
        <span v-show="!loading">Edytuj</span>
        <span v-show="loading">
          <b-spinner small label="Loading..."></b-spinner>
        </span>
      </b-button>
    </b-form-group>
  </b-form>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { required, maxLength } from "vuelidate/lib/validators";

const isPhone = value =>
  /(?:(?:(?:\+|00)?48)|(?:\(\+?48\)))?(?:1[2-8]|2[2-69]|3[2-49]|4[1-68]|5[0-9]|6[0-35-9]|[7-8][1-9]|9[145])\d{7}/.test(
    value
  ); //phone validation https://github.com/skotniczny/phonePL

export default {
  data() {
    return {
      firstName: "",
      lastName: "",
      phoneNumber: "",
      skypeLogin: "",

      hidePassword: true,
      loading: false
    };
  },
  validations: {
    firstName: {
      required,
      maxLength: maxLength(128)
    },
    lastName: {
      required,
      maxLength: maxLength(128)
    },
    phoneNumber: {
      required,
      isPhone
    },
    skypeLogin: {
      required,
      maxLength: maxLength(128)
    }
  },
  mounted() {
    this.loading = true;

    axios
      .get("/UserProfile")
      .then(response => {
        this.firstName = response.data.firstName;
        this.lastName = response.data.lastName;
        this.phoneNumber = response.data.phoneNumber;
        this.skypeLogin = response.data.skypeLogin;
      })
      .catch(error => eventBus.$emit("unhandled-error", error))
      .then(() => (this.loading = false));
  },
  computed: {
    passwordType() {
      return this.hidePassword ? "password" : "text";
    },
    passwordIcon() {
      return this.hidePassword ? "eye" : "eye-slash";
    }
  },
  methods: {
    onSubmit() {
      if (!this.$v.$error) {
        this.loading = true;

        axios
          .put("/UserProfile", {
            FirstName: this.firstName,
            LastName: this.lastName,
            PhoneNumber: this.phoneNumber,
            SkypeLogin: this.skypeLogin
          })
          .then(() =>
            eventBus.$emit("notify-success", "Dane zostały poprawnie zapisane")
          )
          .catch(error => eventBus.$emit("unhandled-error", error))
          .then(() => (this.loading = false));
      }
    },
    goto(url) {
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
fieldset.form-group {
  width: 90%;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
</style>